import { PropsWithChildren } from 'react';

type DialogTitleWithIconProps = {
  text: string;
};

export const DialogTitleWithIcon = ({
  text,
  children,
}: PropsWithChildren<DialogTitleWithIconProps>) => {
  return (
    <div className="flex gap-2 items-center self-stretch">
      {children}
      <span className="translate-y-px">{text}</span>
    </div>
  );
};
